module.exports = __webpack_public_path__ + "static/media/ic-burger.7cecd99b.svg";